import React, { useState } from 'react';
import './Page.css';
import './ContactUs.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the form data to a backend
    console.log('Contact Form Submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Contact Us</h1>
        <p className="contact-intro">
          Have questions or need assistance? We're here to help! As an Indian startup, 
          we're committed to providing personalized support to all our learners across India.
        </p>

        <div className="contact-content">
          <div className="contact-info">
            <section className="page-section">
              <h2>Get in Touch</h2>
              <div className="info-item">
                <h3>📧 Email</h3>
                <p>care@extrabyte.in</p>
              </div>
              <div className="info-item">
                <h3>📞 Phone</h3>
                <p>+91 98765 43210</p>
                <p className="info-subtext">Monday - Saturday, 9:00 AM - 7:00 PM IST</p>
              </div>
              <div className="info-item">
                <h3>📍 Office</h3>
                <p>ExtraByte, Kothanur Main Road, Puttenahalli,</p>
                <p>JP Nagar 7th Phase, J. P. Nagar, Bangalore 593002</p>
              </div>
              <div className="info-item">
                <h3>⏱️ Response Time</h3>
                <p>We typically respond within 24 hours</p>
                <p className="info-subtext">Average response time: 4-6 hours during business days</p>
              </div>
            </section>

            <section className="page-section">
              <h2>Frequently Asked Questions</h2>
              <p>Before reaching out, check our FAQ section:</p>
              <ul>
                <li>Course enrollment and payment options (UPI, Cards, Net Banking)</li>
                <li>Certificate verification and downloads</li>
                <li>Technical support and platform access</li>
                <li>Refund and cancellation policies</li>
                <li>Internship completion requirements</li>
              </ul>
            </section>
          </div>

          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this regarding?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Please provide details about your inquiry..."
                />
              </div>

              <button type="submit" className="submit-btn">
                {submitted ? '✓ Message Sent!' : 'Send Message'}
              </button>

              {submitted && (
                <p className="success-message">
                  Thank you for contacting us! We'll get back to you soon.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
